import { Workspace } from '@gripp/shared-logic';
import { TFunction } from 'i18next';
import { View } from 'react-native';
import { Text } from 'react-native-paper';
import { textStyles } from '../../styles';
import { themedStyleSheet } from '../../themes/themedStyleSheet';

export const InvitationIntro = ({
  workspace,
  t,
}: {
  workspace?: Workspace;
  t: TFunction;
}) => {
  return (
    <View style={styles.container}>
      <Text style={styles.intro}>
        {t('invitation.pending.joining', { workspaceName: workspace?.name })}
      </Text>
      <Text style={textStyles.default}>...</Text>
    </View>
  );
};

const styles = themedStyleSheet((role) => ({
  container: {
    backgroundColor: role.surfaceHover,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  intro: {
    fontSize: 22,
    fontWeight: '700',
    color: role.textStrong,
  },
}));
